export default __webpack_public_path__ + "static/media/I-become-a-mother-BG.fa6d47c3.png";